// GalleryEditor.jsx — Gère une galerie de photos (url + légende) pour la vitrine.
import ImageUploader from './ImageUploader';
import { mediaUrl } from '@/lib/media';
import { X, ChevronUp, ChevronDown } from 'lucide-react';

export default function GalleryEditor({ items = [], onChange, max = 24 }) {
  const list = Array.isArray(items) ? items : [];

  const add = (url) => { if (url) onChange([...list, { url, legende: '' }]); };
  const remove = (i) => onChange(list.filter((_, idx) => idx !== i));
  const setLegende = (i, legende) => onChange(list.map((it, idx) => (idx === i ? { ...it, legende } : it)));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= list.length) return;
    const copy = [...list];
    [copy[i], copy[j]] = [copy[j], copy[i]];
    onChange(copy);
  };

  return (
    <div data-testid="gallery-editor">
      {list.length > 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-4">
          {list.map((it, i) => (
            <div key={i} className="relative group border border-slate-200 rounded-xl overflow-hidden bg-slate-50" data-testid={`gallery-item-${i}`}>
              <img src={mediaUrl(it.url)} alt="" className="w-full aspect-video object-cover" />
              <button type="button" onClick={() => remove(i)} className="absolute top-1.5 right-1.5 w-6 h-6 rounded-full bg-rose-500 hover:bg-rose-600 text-white grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity shadow" data-testid={`gallery-remove-${i}`} aria-label="Supprimer">
                <X className="w-3.5 h-3.5" />
              </button>
              <div className="absolute top-1.5 left-1.5 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                <button type="button" onClick={() => move(i, -1)} className="w-6 h-6 rounded-md bg-black/50 hover:bg-black/70 text-white grid place-items-center" aria-label="Monter"><ChevronUp className="w-3.5 h-3.5" /></button>
                <button type="button" onClick={() => move(i, 1)} className="w-6 h-6 rounded-md bg-black/50 hover:bg-black/70 text-white grid place-items-center" aria-label="Descendre"><ChevronDown className="w-3.5 h-3.5" /></button>
              </div>
              <input value={it.legende || ''} onChange={(e) => setLegende(i, e.target.value)} placeholder="Légende (optionnel)" maxLength={120} className="w-full text-xs px-2 py-1.5 border-t border-slate-200 outline-none focus:bg-slate-50" data-testid={`gallery-legende-${i}`} />
            </div>
          ))}
        </div>
      )}
      {list.length < max ? (
        <ImageUploader value="" onChange={add} label={`Ajouter une photo (${list.length}/${max})`} testid="gallery-add" aspect="auto" hint="La photo s'ajoute à la galerie" />
      ) : (
        <p className="text-xs text-slate-400">Maximum {max} photos atteint.</p>
      )}
    </div>
  );
}
